import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: var(--t-images-border-radius, 14px);

  & > * {
    width: 100%;
    height: 100%;
  }
`;
